export enum SectionType {
  SESSION_FORM_SUMMARY = 'SESSION_FORM_SUMMARY',
  CASE_SUMMARY = 'CASE_SUMMARY',
  TREATMENT_PLAN_SUMMARY = 'TREATMENT_PLAN_SUMMARY',
}

export enum ConsultationReviewCommentsStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  SUCCESS = 'SUCCESS',
}